import axios from 'axios';
import API_BASE_URL from '../config.js';

const cancelReservation = async (reservation_id) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/reservations-cancel/${reservation_id}/`, 
        );
        const resp= {
            "message":response.data.message,
            "status":response.status
        }
    
        return resp;
      } catch (error) {
        return error.response.data
      }
    

};

export default cancelReservation;
